import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", null, "Schwerpunkt(e) auswählen", -1)
const _hoisted_2 = { class: "questionnaire-list" }
const _hoisted_3 = { class: "row-level2" }
const _hoisted_4 = { class: "checkbox" }
const _hoisted_5 = ["id", "onUpdate:modelValue"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "progress-container" }

import {useStore} from "vuex";
import AppActivity from "@/components/AppActivity.vue";

import {ICON_CANCEL, ICON_OK, ICON_REPORT_ICON} from "@/lib/icons";
import {useRoute, useRouter} from "vue-router";
import QuestionnaireEntity from "@/db/QuestionnaireEntity";
import getDb from "@/db/Database";
import QuestionnaireRelease from "@/api/types/QuestionnaireRelease";
import UserQuestionnaire from "@/api/types/UserQuestionnaire";
import QuestionnaireCategoryEntity from "@/db/QuestionnaireCategoryEntity";
import {ref} from "vue";
import QuestionnaireCategory from "@/api/types/QuestionnaireCategory";
import {hideSpinner, showAlert, showSpinner} from "@/store";
import UserQuestionnaireCategoryEntity from "@/db/UserQuestionnaireCategoryEntity";
import UserQuestionnaireCategory from "@/api/types/UserQuestionnaireCategory";
import QuestionnaireTopicEntity from "@/db/QuestionnaireTopicEntity";
import UserQuestionnaireTopicEntity from "@/db/UserQuestionnaireTopicEntity";
import UserQuestionnaireTopic from "@/api/types/UserQuestionnaireTopic";
import QuestionnaireTopic from "@/api/types/QuestionnaireTopic";
import ReportRequest from "@/api/requests/ReportRequest";
import GetReportResponse from "@/api/responses/GetReportResponse";
import {useApiClient} from "@/api";

type TopicEntry = QuestionnaireTopic & {
  userTopic: UserQuestionnaireTopic
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TopicOverviewActivity',
  setup(__props) {

const icons = [
  ICON_REPORT_ICON,
  ICON_CANCEL
]

const store = useStore()
const router = useRouter()
const route = useRoute()
const api = useApiClient()

const mode: string = <string>route.params.mode

const allTopics = ref<TopicEntry[]>([])

const userQuestionnaire: UserQuestionnaire = store.state.currentQuestionnaire
const release: QuestionnaireRelease = store.state.currentRelease

const checkStatus = ref<{ [id: number]: boolean }>({})

const onIconClick = async (icon: string) => {
  switch (icon) {
    case ICON_REPORT_ICON:
      const selectedTopics: QuestionnaireTopic[] = Object.keys(checkStatus.value)
          .filter((id: any) => !!checkStatus.value[id])
          .map((id: any) => {
            id = parseInt(id)
            const searchRes = allTopics.value.filter(topic => topic.id === id)
            if (!searchRes) {
              showAlert('Ein interner Fehler ist aufgetreten')
              throw new Error(`topic with id ${id} not found`)
            }
            return searchRes[0]
          })

        store.commit('SET_SELECTED_TOPICS', selectedTopics)

        if (mode !== 'optimize') {
          await router.push({ name: 'comparisonChoice' })
        } else {
          await (async () => {
            showSpinner()

            const request = new ReportRequest(2, userQuestionnaire.description, <number>userQuestionnaire.id)
            request.comparison = 0
            request.topics = selectedTopics.map((topic: QuestionnaireTopic) => topic.id)

            api.createReport(store.state.configuration.sessionId, request)
                .then(async (res: GetReportResponse) => {
                  try {
                    await res.openFile()
                  } catch (error: any) {
                    showAlert('Fehler: ' + error.message)
                  }
                  hideSpinner()
                })
                .catch(err => {
                  console.error('ERROR', err)
                  hideSpinner()
                })
          })()
        }
      break
    case ICON_CANCEL:
      store.commit('SET_QUESTIONNAIRE', { questionnaire: null, release: null })
      await router.push({ name: 'questionnaire' })
      break
  }
}

const load = async () => {
  showSpinner()
  const questionnaire = await QuestionnaireEntity.find(getDb(), release.questionnaireId)
  if (questionnaire) {
    const topics = await QuestionnaireTopicEntity.findAllByQuestionnaire(getDb(), questionnaire.id)
    if (topics) {
      topics.sort((a, b) => <string>a.name > <string>b.name ? 1 : -1)

      // @ts-ignore
      allTopics.value = await Promise.all(topics.map(async (topic) => {
        if (typeof checkStatus.value[topic.id] === 'undefined') {
          checkStatus.value[topic.id] = mode !== 'optimize'
        }
        return {
          ...topic,
          userTopic: await UserQuestionnaireTopicEntity.findByTopicId(getDb(), <number>userQuestionnaire.pk, topic.id)
        }
      }))
    }
  }
  hideSpinner()
}

if (!userQuestionnaire || !release) {
  router.push({ name: 'questionnaire' })
} else {
  load()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppActivity, {
    title: "Risiko - Analyse",
    id: "category-filter-activity",
    icons: icons,
    onIconClick: onIconClick
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allTopics.value, (topic) => {
          return (_openBlock(), _createElementBlock("li", {
            key: topic.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  id: topic.id,
                  "onUpdate:modelValue": ($event: any) => ((checkStatus.value[topic.id]) = $event),
                  checked: ""
                }, null, 8, _hoisted_5), [
                  [_vModelCheckbox, checkStatus.value[topic.id]]
                ])
              ]),
              _createElementVNode("label", {
                for: topic.id,
                class: "name"
              }, _toDisplayString(topic.name), 9, _hoisted_6),
              _createElementVNode("div", _hoisted_7, _toDisplayString(topic.userTopic?.progress || 0) + "%", 1)
            ])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }))
}
}

})